import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export enum GlobalConfirmPromptStatus {
  PENDING = 'PENDING',
  IDLE = 'IDLE',
  PROCESSING = 'PROCESSING',
}

interface GlobalConfirmPromptState {
  isOpen: boolean;
  title: string;
  message: string;
  dataId?: string | number;
  status: GlobalConfirmPromptStatus;
  isLoading: boolean;
  module: string;
}

const initialState: GlobalConfirmPromptState = {
  isOpen: false,
  title: '',
  message: '',
  dataId: undefined,
  status: GlobalConfirmPromptStatus.IDLE,
  isLoading: false,
  module: 'default',
};

export const globalConfirmPromptSlice = createSlice({
  name: 'globalConfirmPrompt',
  initialState,
  reducers: {
    openConfirmPrompt: (
      state,
      action: PayloadAction<{ title: string; message: string; dataId?: string; module?: string }>,
    ) => {
      state.isOpen = true;
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.dataId = action.payload.dataId;
      state.module = action.payload.module || 'default';
    },
    closeConfirmPrompt: state => {
      state.isOpen = false;
      state.title = '';
      state.message = '';
      state.dataId = undefined;
      state.isLoading = false;
      state.status = GlobalConfirmPromptStatus.IDLE;
    },
    confirmPromptProcessing: state => {
      state.status = GlobalConfirmPromptStatus.PROCESSING;
      state.isLoading = true;
    },
    pendingConfirmPrompt: state => {
      state.status = GlobalConfirmPromptStatus.PENDING;
      state.isLoading = false;
    },
  },
});

export const {
  openConfirmPrompt,
  closeConfirmPrompt,
  confirmPromptProcessing,
  pendingConfirmPrompt,
} = globalConfirmPromptSlice.actions;

export default globalConfirmPromptSlice.reducer;
